export default "__VITE_ASSET__BcwmfKuN__"